import classnames from 'classnames'
import React,
{ Component } from 'react'
import { DragSource } from 'react-dnd'

import DropTarget from './DropTarget'

const boxSource = {
  canDrag(props) {
    return true
  },

  isDragging(props, monitor) {
    return monitor.getItem().id === props.id
  },

  beginDrag(props, monitor, component) {
    const item = { id: props.id }

    return item
  }
}

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
})

class Draggable extends Component {

  render() {
    const {
      id,
      connectDragSource,
      connectDragPreview,
      onReorder,
      isDragging,
      currentSettingsObject,
      children,
      type,
    } = this.props

    return (
      <DropTarget
        id={id}
        onReorder={onReorder}
        currentSettingsObject={currentSettingsObject}
        type={type}
      >
        <div className={classnames('node-draggable', { 'drop-target--dragging': isDragging })}>
          {
            connectDragPreview(connectDragSource(children))
          }
        </div>
      </DropTarget>
    )
  }
}

export default DragSource(props => props.type,
  boxSource,
  collect)(Draggable)
